export interface WallDef {
  x: number;   // centre X
  z: number;   // centre Z
  hw: number;  // half-width  (X axis extent)
  hd: number;  // half-depth  (Z axis extent)
}

/**
 * Interior arena walls — used for client-side movement prediction and
 * visual rendering. Mirrored verbatim from server/src/data/wallDefs.ts.
 * Keep both files in sync.
 */
export const WALL_DEFS: WallDef[] = [
  // ── Centre cross ─────────────────────────────────────────────
  { x:   0, z:   0, hw: 14,  hd: 1.5 },  // East-West bar  (28 × 3 units)
  { x:   0, z:   0, hw: 1.5, hd: 14  },  // North-South bar (3 × 28 units)

  // ── Mid-ring cover (cardinal, ~32 units from centre) ─────────
  { x:   0, z: -32, hw: 11,  hd: 1.5 },  // North
  { x:   0, z:  32, hw: 11,  hd: 1.5 },  // South
  { x: -32, z:   0, hw: 1.5, hd: 11  },  // West
  { x:  32, z:   0, hw: 1.5, hd: 11  },  // East

  // ── Outer quadrant cover (~55 units diagonal) ─────────────────
  { x: -55, z: -55, hw: 10,  hd: 1.5 },  // NW horizontal
  { x:  55, z: -55, hw: 10,  hd: 1.5 },  // NE horizontal
  { x: -55, z:  55, hw: 10,  hd: 1.5 },  // SW horizontal
  { x:  55, z:  55, hw: 10,  hd: 1.5 },  // SE horizontal
];
